<div>
  <h1 class="page-header">Login/Logout - {{ logData.model }}</h1>
</div>

<div class="table-responsive">
  <table class="table table-bordered mb-0">
    <thead>
      <tr>
        <th>Field</th>
        <th>Value</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Action</td>
        <td>{{ logData?.action || 'N/A' }}</td>
      </tr>
      <tr>
        <td>User</td>
        <td>{{ logData?.user || 'N/A' }}</td>
      </tr>
      <tr>
        <td>Super Admin Login</td>
        <td>{{ logData?.super_admin_login || 'N/A' }}</td>
      </tr>
      <tr>
        <td>Date Time</td>
        <td>{{ logData?.date_time | timezone}}</td>
      </tr>
      <tr>
        <td>User Agent</td>
        <td>{{ logData?.user_agent || 'N/A' }}</td>
      </tr>
      <tr>
        <td>IP</td>
        <td>{{ logData?.ip || 'N/A' }}</td>
      </tr>
      <tr>
        <td>ID</td>
        <td>{{ logData?.id || 'N/A' }}</td>
      </tr>
      <tr>
        <td>Logged In As</td>
        <td>{{ logData?.logged_in_as || 'N/A' }}</td>
      </tr>
    </tbody>
  </table>
</div>
